import { render, staticRenderFns } from "./PopupListDefaultLayout.vue?vue&type=template&id=998b8794&scoped=true&"
import script from "./PopupListDefaultLayout.vue?vue&type=script&lang=js&"
export * from "./PopupListDefaultLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "998b8794",
  null
  
)

export default component.exports